import {Subset} from '@wandb/weave/common/types/base';

import {BenchmarkProject} from '../../types/graphql';
import * as Benchmark from '../../util/benchmark';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import catz from './BenchmarkCatz';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import colorizer from './BenchmarkColorizer';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import drought from './BenchmarkDrought';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import mnist from './BenchmarkFashionMnist';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import kmnist from './BenchmarkKmnist';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import safelife from './BenchmarkSafelife';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import superres from './BenchmarkSuperres';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import test from './BenchmarkTest';
import {Theme} from './benchmarkTypes';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import userCreated from './BenchmarkUserCreated';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import witness from './BenchmarkWitness';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import github from './GitHub';

export type {Theme} from './benchmarkTypes';

export const checkTheme = (
  benchmark: Subset<BenchmarkProject, 'name' | 'entityName'>
): Theme | null => {
  if (
    benchmark.name === 'codenet' ||
    benchmark.name === 'codesearchnet' ||
    benchmark.name === 'codesearch-test'
  ) {
    return github;
  } else if (benchmark.name === '__benchmark-test') {
    return test;
  }

  if (benchmark.entityName === 'wandb') {
    if (benchmark.name === 'fashion-mnist-benchmark') {
      return mnist;
    } else if (benchmark.name === 'colorizer-applied-dl') {
      return colorizer;
    } else if (benchmark.name === 'catz') {
      return catz;
    } else if (benchmark.name === 'droughtwatch') {
      return drought;
    } else if (benchmark.name === 'kmnist') {
      return kmnist;
    } else if (benchmark.name === 'benchmark-test') {
      return test;
    } else if (benchmark.name === 'gh-test-benchmark') {
      return test;
    } else if (benchmark.name === 'codesearch-benchmark') {
      return test;
    } else if (benchmark.name === 'witness') {
      return witness;
    } else if (benchmark.name === 'superres') {
      return superres;
    }
  }

  if (
    benchmark.entityName === 'safelife' &&
    (benchmark.name === 'test_stacey' || benchmark.name === 'v1dot2')
  ) {
    return safelife;
  }

  if (benchmark.views != null) {
    try {
      const json = JSON.parse(benchmark.views);
      const fields = Benchmark.fromJSON(json);
      return userCreated(fields);
    } catch (e) {
      console.warn("Coudn't parse benchmark views ", benchmark.views);
    }
  }
  return null;
};

export const getTheme = (benchmark: BenchmarkProject): Theme => {
  const theme = checkTheme(benchmark);
  if (theme == null) {
    throw new Error(`No match for Benchmark: ${benchmark.name}`);
  }
  return theme;
};
